<template>
  <f7-page class="rowBackgroundHomepage" :class="customPageClass">
    <!-- <div v-else style="height:20px;"></div> -->
    <b-container fluid :class="{customContainer: !noReduce}">
      <!-- <b-row v-if="!isSmartphoneOS && !noReturn" class="w-100">
        <b-col md="12" class="p-0">
          <back-button id="back-button" :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col :md="colWidth" :offset-md="(12 - colWidth)/2" class="p-0">
          <div class="panel21 panel-default">
            <div class="panel-heading d-flex justify-content-start mb-10px ml-1">
              <div class="formTitleBlock">
                <h4 class="content-block labelAccordionForm justify-content-center panel-title">
                  <!-- <f7-icon v-if="icon" :icon="icon" class="formIcon"></f7-icon> -->
                  <!-- <f7-icon v-else-if="iconF7" :f7="iconF7"></f7-icon> -->
                  <!-- <f7-icon v-else-if="iconFA" :fa="iconFA"></f7-icon> -->
                  <!-- <slot name="icon"></slot> -->
                  <slot name="titleContent">
                    <span class="fs-24px">{{ title }}</span>
                  </slot>
                </h4>
              </div>
              <!-- <div class="showSmallScreenOnly formTitleBlock">
                <h6 class="content-block labelAccordionForm creationFormTitle"
                  :style="{color}">
                  <f7-icon v-if="icon" :icon="icon" class="formIcon"></f7-icon>
                  <f7-icon v-if="iconF7" :f7="iconF7"></f7-icon>
                  <f7-icon v-if="iconFA" :fa="iconFA"></f7-icon>
                  <slot name="icon"></slot>
                  <slot name="titleContent">
                    <span>{{ title }}</span>
                  </slot>
                </h6>
              </div> -->
              <div v-if="mandatoryIndication" class="content-block italicMandatoryIndication">
                {{ $t('common.asterisk_obligation_label')}}
              </div>
            </div>
            <slot name="pageContent"></slot>
          </div>
          <slot name="underPanel"></slot>
        </b-col>
      </b-row>
      <slot name="footerButtons"></slot>
      <!-- <div class="toolbarPageBottomBlank"></div> -->
      <footer class="pb-10px">
        <b-row>
          <b-col class="xs-12 text-center">
            <b-col class="md-offset-3 md-6">
              <img class="logoStreammind" :src="logoStreammind"></img>
              <span> {{ $t('common.copyright')}}</span>
            </b-col>
          </b-col>
        </b-row>
      </footer>
    </b-container>
  </f7-page>
</template>

<script>
import StreammindImage from './../../assets/static/images/streammind-text-seul.png'
import backButton from '@/components/common/backButton.vue'
import bgImg from '../../assets/static/images/header/essai-lg.jpg'
export default {
  name: 'PageOutline',
  components: {
    'back-button': backButton
  },
  props: {
    color: {
      default: 'var(--actionTextColor)'
    },
    colWidth: {
      default: '10'
    },
    icon: {
      default: ''
    },
    iconF7: {
      default: ''
    },
    iconFA: {
      default: ''
    },
    mandatoryIndication: {
      type: Boolean,
      default: false
    },
    noReduce: {
      type: Boolean,
      default: false
    },
    noReturn: {
      type: Boolean,
      default: false
    },
    pageClass: {
      type: String,
      default: ''
    },
    returnUrl: {
      default: 'none'
    },
    title: {
      default: 'Title'
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
    return {
      logoStreammind: StreammindImage,
      bgImage: 'background-image: linear-gradient(rgba(255,255,255,0),rgba(255,255,255,1)),url('+ bgImg +');background-position:bottom;background-size:cover;top:84px;height:370px;',
      customPageClass: ''
    }
  },
  created () {
    this.customPageClass = this.pageClass
    this.$bus.$emit('change-mobile-header', {
      backLink: true,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.title,
      returnUrl: this.returnUrl
    })
  }
}
</script>
